const ALERT = {
  FAIL_RESET: '현재 스탯 초기화를 할 수 없습니다. 잠시 후, 다시 시도해주세요.',
  FAIL_LOAD_SAVED_STAT: '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',

  CONFIRM_RESET: '초기화를 하면 레벨은 50으로, 입력하신 스탯포인트는 모두 베이스 스탯으로 초기화 됩니다.',

  CAN_SAVE_STAT_AFTER_LOGIN: '스탯 세팅 저장은 로그인 후 이용 가능합니다.',
  CAN_MODIFY_STAT_AFTER_LOGIN: '스탯 세팅 수정은 로그인 후 이용 가능합니다.',
  CAN_DELETE_STAT_AFTER_LOGIN: '스탯 세팅 삭제는 로그인 후 이용 가능합니다.',

  SAVE_STAT_LIMIT: `스탯 세팅 저장은 계정당 최대 6개까지 가능합니다.
새 세팅 결과 저장을 원한다면 기존 저장 내용 삭제 후 이용해주세요.
스탯 세팅을 계속 진행하시겠습니까?`,

  TRY_DELETE_STAT: (data) => `${data.level}Lv 스탯 세팅을 삭제하시겠습니까?`,
  FAIL_DELETE_STAT: '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.',

  FAIL_SAVE_STAT: '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.',
  CAN_LEVELUP_AFTER_INIT_BASE_STAT: '베이스 스탯 포인트 분배 후에 레벨업하실 수 있습니다.',
  CAN_LEVELUP_AFTER_EXHAUST_REMAIN_STAT: '남은 스탯을 모두 사용하셔야 레벨업하실 수 있습니다.',
  CAN_PROCESS_AFTER_EXHAUST_ELIXIR_STAT: '엘릭서의 스탯을 모두 사용하셔야 다음 진행을 하실 수 있습니다.',
  FAIL_CALCULATE_STAT: '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.',

  COMPLETE_DISTRIBUTE_BASE_STAT: `베이스 스탯을 모두 분배하셨습니다.
이제 레벨업으로 원하는 스탯에
보너스 스탯 포인트를 분배하실 수 있습니다.`,

  REMAIN_STAT_ZERO: '사용하실 수 있는 스탯 포인트를 모두 사용하셨습니다.',
  IMPOSSIBLE_LEVEL_CONSUME_ELIXIR_STAT: '엘릭서 스탯 포인트를 사용할 수 없는 레벨입니다.',
  NO_UNDO_STAT: '되돌릴 수 있는 스탯 포인트가 없습니다.',
  REQUIRE_EXHAUST_STAT: '남은 스탯 포인트를 모두 배분해주세요.'
};

export {
  ALERT
};


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/model/msg/stat.js